import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, Note, NoteWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateNote(): UseMutationResult<
  AxiosResponse<Note>,
  AxiosError<ErrorMessage>,
  NoteWrite
> {
  const queryClient = useQueryClient();

  const createNote = (note: NoteWrite): Promise<AxiosResponse<Note>> => {
    return client.post('notes/', note);
  };

  return useMutation(createNote, {
    onSuccess: () => {
      queryClient.invalidateQueries('notes');
    },
  });
}
